export default {
  title: 'Nowy wariant',
  fields: {
    product: {
      label: 'Produkt',
    },
    name: {
      label: 'Nazwa',
      placeholder: 'Duży',
    },
    price: {
      label: 'Dodatkowa cena',
    },
  },
  buttons: {
    save: 'Zapisz',
    close: 'Zamknij',
  },
  toasts: {
    variant_got_created: 'Wariant został utworzony',
    variant_got_updated: 'Wariant został zaktualizowany',
  },
};
